// src/context/ModalContext.js
import { createContext, useContext } from "react";

export const ModalContext = createContext({
  openLogin: () => {},
  openRegister: () => {},
});

export const useModal = () => useContext(ModalContext);
